
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b1458204999 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"×10^","‰":"‰"},]);
Globalize.b1165082887 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"×10^","‰":"‰"},]);
Globalize.a2031160443 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"−","E":"×10^","‰":"‰"},]);
Globalize.b1228670462 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","×10^":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a136552493 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.b997288091 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1765665403 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1176609222 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b737641005 = messageFormatterFn((function(  ) {
  return function(d) { return "Lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b13752590 = messageFormatterFn((function(  ) {
  return function(d) { return "Detta är en offentlig eller delad enhet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1564767573 = messageFormatterFn((function(  ) {
  return function(d) { return "Är detta inte din enhet? Om du markerar denna kryssruta minskas tiden du är inloggad här."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b327549690 = messageFormatterFn((function(  ) {
  return function(d) { return "Håll mig inloggad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b543715416 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att klicka för den här rutan kommer du att förbli inloggad på den här enheten tills du loggar ut. Välj inte detta på enheter som delas med andra."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b374854160 = messageFormatterFn((function(  ) {
  return function(d) { return "Glömt lösenordet?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1062413279 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsätt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b924375950 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b222695145 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå tillbaka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1031761817 = messageFormatterFn((function(  ) {
  return function(d) { return "Uppdatera"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b910865314 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att logga in godkänner jag <a href=" + d["1"] + " " + d["3"] + ">regler och villkor</a> för " + d["0"] + " och <a href=" + d["2"] + " " + d["4"] + ">sekretessmeddelandet</a>."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1222577348 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att logga in godkänner jag <a href=" + d["1"] + " " + d["5"] + ">regler och villkor</a> för " + d["0"] + ", <a href=" + d["2"] + " " + d["6"] + ">sekretessmeddelandet</a> samt <a href=" + d["3"] + " " + d["7"] + ">regler och villkor för " + d["4"] + "</a>."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b622131628 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att logga in registrerar jag mig även i " + d["4"] + ". Jag godkänner samtliga <a href=" + d["1"] + " " + d["5"] + ">regler och villkor</a> och <a href=" + d["2"] + " " + d["6"] + ">sekretessmeddelandet</a> för " + d["0"] + " samt <a href=" + d["3"] + " " + d["7"] + ">regler och villkor för " + d["4"] + "</a>."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b299411159 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt konto har pausats till följd av en rutinmässig säkerhetskontroll. Din information är säker, men du måste återställa ditt lösenord. Klicka på länken “Glömt lösenordet?” nedan för att logga in och ändra lösenord."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1145196449 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadressen och lösenordet matchar inte varandra. Försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1898460134 = messageFormatterFn((function(  ) {
  return function(d) { return "Något gick tyvärr snett på vårt håll."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2087898336 = messageFormatterFn((function(  ) {
  return function(d) { return "Något gick tyvärr snett på vårt håll. Vänta en stund och försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a797976126 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange din e-postadress."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1359710769 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange giltig e-postadress."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b833313461 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ditt lösenord."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1877832309 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontrollerar inloggningsuppgifter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1303152720 = messageFormatterFn((function(  ) {
  return function(d) { return "Dölj lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b988810581 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b612909773 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du inget konto? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Skapa ett</a></span>"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1659589512 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1683872335 = messageFormatterFn((function(  ) {
  return function(d) { return "Inloggning via " + d["0"] + " är inte längre ett alternativ"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1855844395 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan använda samma e-postadress för att logga in på ditt " + d["0"] + "-konto om du återställer ditt lösenord. Detta kommer inte att påverka ditt " + d["1"] + "-konto."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1723858493 = messageFormatterFn((function(  ) {
  return function(d) { return "Återställ ditt lösenord genom att klicka på knappen nedan. Nästa gång kan du logga in direkt på " + d["0"] + " med din e-postadress och det nya lösenordet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1960340028 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO inloggning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b726368380 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in med single sign-on"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1190854928 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller använd ditt " + d["0"] + "-konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a357253411 = messageFormatterFn((function(  ) {
  return function(d) { return "Tjäna poäng mot resor. Spara med medlemspriser. Smidig tillgång till dina resplaner."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a922665789 = messageFormatterFn((function(  ) {
  return function(d) { return "Tjäna " + d["0"] + " Expedia Rewards-poäng efter den här resan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b487757690 = messageFormatterFn((function(  ) {
  return function(d) { return "Inloggning på " + d["0"] + "-konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1104224920 = messageFormatterFn((function(  ) {
  return function(d) { return "Glömt lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1304027615 = messageFormatterFn((function(  ) {
  return function(d) { return "Återställ ditt lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a423202663 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange din e-postadress, så skickar vi en länk för att återställa ditt lösenord."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1965034149 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka länk"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1389794786 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolla din inkorg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b597579834 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har skickat ett e-postmeddelande till " + d["0"] + " med en länk för att återställa ditt lösenord."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b597578873 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan ta några minuter innan e-postmeddelandet kommer. Kolla i din skräppostmapp om inget har kommit efter 10 minuter."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a397701679 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka ny länk"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b983071255 = messageFormatterFn((function(  ) {
  return function(d) { return "En ny länk har skickats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1980232316 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifierar konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2067356548 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b718147213 = messageFormatterFn((function(  ) {
  return function(d) { return "Välkommen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b975804589 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa ett unikt lösenord för att fortsätta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a833857730 = messageFormatterFn((function(  ) {
  return function(d) { return "Klart!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a236693819 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd det nya lösenordet för att komma igång."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a453318826 = messageFormatterFn((function(  ) {
  return function(d) { return "Återställ lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1161554515 = messageFormatterFn((function(  ) {
  return function(d) { return "Länken har tyvärr gått ut. Om du fortfarande behöver återställa ditt lösenord kan du klicka nedan för att skicka ett till e-postmeddelande."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1733404707 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka ny länk"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b359652018 = messageFormatterFn((function(  ) {
  return function(d) { return "Lösenordet sparas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b250195330 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b66311890 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa ett konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a954332413 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b543922571 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange din e-postadress."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1185482054 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange giltig e-postadress."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a920035228 = messageFormatterFn((function(  ) {
  return function(d) { return "Förnamn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1938003220 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ditt förnamn."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b596869950 = messageFormatterFn((function(  ) {
  return function(d) { return "Efternamn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1810958262 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ditt efternamn."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1585966531 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange namn med endast bokstäver"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a253512508 = messageFormatterFn((function(  ) {
  return function(d) { return "Lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b960575804 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ditt lösenord."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1599892051 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange giltigt lösenord."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1990542157 = messageFormatterFn((function(  ) {
  return function(d) { return "Innehåller 9-64 tecken"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1990543118 = messageFormatterFn((function(  ) {
  return function(d) { return "Kombination av bokstäver och siffror"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1990544079 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett specialtecken, som till exempel ~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1990545040 = messageFormatterFn((function(  ) {
  return function(d) { return "Lösenordet får inte innehålla mellanslag."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a876892681 = messageFormatterFn((function(  ) {
  return function(d) { return "Lösenordet måste bestå av mellan 8 och 64 tecken"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1833870326 = messageFormatterFn((function(  ) {
  return function(d) { return "Lösenordet får inte vara detsamma som din e-postadress."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a578805043 = messageFormatterFn((function(  ) {
  return function(d) { return "Lösenordet får inte innehålla mellanslag."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b970405973 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att skapa ett konto godkänner jag <a href=" + d["1"] + " " + d["3"] + ">regler och villkor</a> för " + d["0"] + " och <a href=" + d["2"] + " " + d["4"] + ">sekretessmeddelandet</a>."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b555673961 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att skapa ett konto godkänner jag <a href=" + d["1"] + " " + d["5"] + ">regler och villkor</a> för " + d["0"] + ", <a href=" + d["2"] + " " + d["6"] + ">sekretessmeddelandet</a> samt <a href=" + d["3"] + " " + d["7"] + ">regler och villkor för " + d["4"] + "</a>."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1504790280 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag vill ta emot e-postmeddelanden med specialerbjudanden, kampanjer och annan information om resor från " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1565311881 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag vill ta emot e-postmeddelanden med specialerbjudanden, kampanjer och annan information om resor från " + d["0"] + ". Du kan säga upp din prenumeration av marknadsföringsmeddelanden när som helst."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a312684347 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag vill ta emot e-postmeddelanden med reseförslag, specialerbjudanden och annan information från " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a920275732 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag vill ta emot e-postmeddelanden med reseförslag, specialerbjudanden och annan information från " + d["0"] + ". Du kan säga upp din prenumeration av marknadsföringsmeddelanden när som helst."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2053566792 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsätt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a239640651 = messageFormatterFn((function(  ) {
  return function(d) { return "Har du redan ett konto? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Logga in</a></span>"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a53189138 = messageFormatterFn((function(  ) {
  return function(d) { return "Välkommen, " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1386611956 = messageFormatterFn((function(  ) {
  return function(d) { return "Med ditt nya konto hos " + d["0"] + " ligger hela världen inom räckhåll."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2081535421 = messageFormatterFn((function(  ) {
  return function(d) { return "Fortsätt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2119812172 = messageFormatterFn((function(  ) {
  return function(d) { return "Du behöver ha ett starkare lösenord för att gå vidare"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a449361145 = messageFormatterFn((function(  ) {
  return function(d) { return "Måste innehålla minst 8 tecken."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b707845219 = messageFormatterFn((function(  ) {
  return function(d) { return "Lösenordsstyrka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a18660101 = messageFormatterFn((function(  ) {
  return function(d) { return "Svagt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1003468316 = messageFormatterFn((function(  ) {
  return function(d) { return "Starkt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1435390918 = messageFormatterFn((function(  ) {
  return function(d) { return "Väldigt starkt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b36061589 = messageFormatterFn((function(  ) {
  return function(d) { return "Undvik förutsägbara utväxlingar som “@” istället för “a”."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1113961619 = messageFormatterFn((function(  ) {
  return function(d) { return "Undvik att stava vanliga ord baklänges."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1756835835 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd versaler för vissa bokstäver, men inte alla."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1928461786 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd versaler för flera bokstäver och inte bara den första."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1010565366 = messageFormatterFn((function(  ) {
  return function(d) { return "Undvik datum och årtal som har en koppling till dig."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2052140716 = messageFormatterFn((function(  ) {
  return function(d) { return "Undvik årtal om nyss varit."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1729336825 = messageFormatterFn((function(  ) {
  return function(d) { return "Undvik årtal som har en koppling till dig."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a790804742 = messageFormatterFn((function(  ) {
  return function(d) { return "Undvik vanliga teckenkombinationer."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b967632160 = messageFormatterFn((function(  ) {
  return function(d) { return "Undvik upprepade ord och tecken."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b947148220 = messageFormatterFn((function(  ) {
  return function(d) { return "Undvik att skriva långa mönster och byt riktning flera gånger."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b165033239 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till fler ord som är mindre vanliga."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2074570859 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd flera ord men undvik vanliga fraser."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1463185720 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan skapa ett starkt lösenord utan att använda symboler, siffror och versaler."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b878291521 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadressen är redan kopplad till ett konto på " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b876220113 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har skickat ett e-postmeddelande med en länk för att slutföra registreringen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a941253470 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontot håller på att skapas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b227433142 = messageFormatterFn((function(  ) {
  return function(d) { return "Förnamn måste bestå av minst två bokstäver"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b304204700 = messageFormatterFn((function(  ) {
  return function(d) { return "Efternamn måste bestå av minst två bokstäver"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1020616696 = messageFormatterFn((function(  ) {
  return function(d) { return "Förnamnet kan bestå av högst 100 tecken"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a943845138 = messageFormatterFn((function(  ) {
  return function(d) { return "Efternamnet kan bestå av högst 100 tecken"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1981810931 = messageFormatterFn((function(  ) {
  return function(d) { return "Förnamnet får inte innehålla specialtecken"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1218787725 = messageFormatterFn((function(  ) {
  return function(d) { return "Efternamnet får inte innehålla specialtecken"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a689124625 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag godkänner följande"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b736490659 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag bekräftar att jag är över 18 år och att jag godkänner samtliga <a href=" + d["0"] + " " + d["1"] + ">Användarvillkor</a> och <a href=" + d["2"] + " " + d["3"] + ">" + d["4"] + " Regler och villkor</a> (obligatoriskt)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1310529541 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag godkänner insamling och användning av mina personuppgifter som beskrivs i <a href=" + d["0"] + " " + d["1"] + ">sekretesspolicyn</a> (obligatoriskt)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a833469864 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag godkänner att mina personuppgifter kan delas med en tredjepart, antingen i Korea eller utomlands, som beskrivs i <a href=" + d["0"] + " " + d["1"] + ">sekretesspolicyn</a> (obligatoriskt)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b726658267 = messageFormatterFn((function(  ) {
  return function(d) { return "Godkänn villkoren för att fortsätta."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2040837279 = messageFormatterFn((function(  ) {
  return function(d) { return "Godkänn villkoren för att fortsätta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1209611107 = messageFormatterFn((function(  ) {
  return function(d) { return "Kryssa för rutan för att fortsätta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1458219498 = messageFormatterFn((function(  ) {
  return function(d) { return "Eller skapa ett konto med " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1232038760 = messageFormatterFn((function(  ) {
  return function(d) { return "Undvik att använda mellanslag, ditt namn, din e-postadress eller lösenord som du har använt tidigare."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b926870284 = messageFormatterFn((function(  ) {
  return function(d) { return "Något gick tyvärr snett på vårt håll. Vänta en stund och försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b932032294 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifiera ditt mobilnummer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1962777163 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi skickar en engångskod för verifiering till din mobil för att fortsatt garantera säkerheten för ditt konto."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b921860484 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a514142795 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + ". Med ensamrätt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b965239399 = messageFormatterFn((function(  ) {
  return function(d) { return "Regler och villkor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a784859546 = messageFormatterFn((function(  ) {
  return function(d) { return "Sekretesspolicy"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1145533551 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka sms"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1664100614 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange verifieringskod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a19987960 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifieringskod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a443873451 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka ny kod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a370387456 = messageFormatterFn((function(  ) {
  return function(d) { return "Ändra mobilnummer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b804043596 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifieringskoden har skickats på nytt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1082890323 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange den sexsiffriga verifieringskoden som skickades till " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1485869350 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifieringskod kontrolleras"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a960493421 = messageFormatterFn((function(  ) {
  return function(d) { return "Koden stämmer inte. Skicka ny kod för att försöka igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1348111737 = messageFormatterFn((function(  ) {
  return function(d) { return "eller fortsätt med"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a591899529 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara i genomsnitt " + d["0"] + " % på tusentals hotell som medlem — alltid helt gratis."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1134603497 = messageFormatterFn((function(  ) {
  return function(d) { return "eller"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1942035925 = messageFormatterFn((function(  ) {
  return function(d) { return "Andra sätt att logga in"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1942395339 = messageFormatterFn((function(  ) {
  return function(d) { return "Andra sätt att registrera sig"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1571034977 = messageFormatterFn((function(  ) {
  return function(d) { return "Registrera dig med Google"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a184150270 = messageFormatterFn((function(  ) {
  return function(d) { return "Inloggning misslyckades. Försök igen eller skapa ett konto på sidan för att fortsätta."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b54747400 = messageFormatterFn((function(  ) {
  return function(d) { return "Det är inte möjligt att logga in via ett telefonnummer. Se till att ditt konto på det sociala mediet är ställt in på att dela din e-postadress."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a603780592 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara minst " + d["0"] + " % på tusentals hotell som medlem — alltid helt gratis."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a390186197 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in med Google"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a143292182 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in med NAVER"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1373588044 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har överskridit maxantalet tillåtna inloggningsförsök. Försök igen senare."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b981715769 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in med biometri"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2072050439 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd biometri för att få tillgång till ditt konto utan att behöva skriva in lösenord."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a138455846 = messageFormatterFn((function(  ) {
  return function(d) { return "Kom igång"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b962234038 = messageFormatterFn((function(  ) {
  return function(d) { return "Påminn mig senare"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a749290816 = messageFormatterFn((function(  ) {
  return function(d) { return "Klart!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b963318470 = messageFormatterFn((function(  ) {
  return function(d) { return "Biometrisk inloggning har aktiverats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1590928098 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in med biometri"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1954400409 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b910195890 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd biometri"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1220851655 = messageFormatterFn((function(  ) {
  return function(d) { return "Uppdatera ditt lösenord för att fortsätta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a614546531 = messageFormatterFn((function(  ) {
  return function(d) { return "Du måste återställa ditt lösenord för att få tillgång till ditt konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a289181639 = messageFormatterFn((function(  ) {
  return function(d) { return "Återställ lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1537208871 = messageFormatterFn((function(  ) {
  return function(d) { return "Välkommen till medlemsförmåner"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a427754303 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi ger dig poäng till ett värde av $" + d["0"] + " i present till ditt nästa äventyr!"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a798715345 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan se dina poäng direkt i ditt konto och använda poängen på din första bokning genom att tillämpa dem på betalningssidan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a308614207 = messageFormatterFn((function(  ) {
  return function(d) { return "Du är nu Expediamedlem."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1400339665 = messageFormatterFn((function(  ) {
  return function(d) { return "Börja spara direkt med medlemspriser och tjäna poäng när du bokar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b203256122 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in eller skapa konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1045778860 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara i genomsnitt " + d["0"] + " % på tusentals hotell som medlem — alltid helt gratis."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1005151506 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att fortsätta medger jag att jag har läst och godkänner samtliga <a href=" + d["1"] + " " + d["3"] + ">regler och villkor</a> och <a href=" + d["2"] + " " + d["4"] + ">sekretessmeddelandet</a>."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1806833612 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att fortsätta medger jag att jag har läst och godkänner samtliga <a href=" + d["1"] + " " + d["5"] + ">regler och villkor</a> och <a href=" + d["2"] + " " + d["6"] + ">sekretessmeddelandet</a> samt <a href=" + d["3"] + " " + d["7"] + ">regler och villkor för " + d["4"] + "</a>."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1306832079 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom att fortsätta medger jag att jag har läst och godkänner samtliga <a href=" + d["1"] + " " + d["4"] + ">regler och villkor</a> och <a href=" + d["2"] + " " + d["5"] + ">sekretessmeddelandet</a> samt <a href=" + d["3"] + " " + d["6"] + ">regler och villkor för lojalitetsprogrammet One Key</a>."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b449738635 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1579795055 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange giltig e-postadress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1493900978 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b637807489 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1090718889 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a635321968 = messageFormatterFn((function(  ) {
  return function(d) { return "Detta är endast till för privata enheter. För att garantera säkerheten för ditt konto bör du inte kryssa för denna ruta på delade enheter."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1011417215 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har försökt att logga in för många gånger. Du måste vänta " + d["0"] + " minuter innan du kan prova igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b808563067 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har försökt att logga in för många gånger. Du måste vänta " + d["0"] + " minut innan du kan prova igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b803667733 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har försökt att logga in för många gånger. Du måste vänta " + d["0"] + " minuter innan du kan prova igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b817125577 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har försökt att logga in för många gånger. Du måste vänta " + d["0"] + " minuter innan du kan prova igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a635434614 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har försökt att logga in för många gånger. Du måste vänta " + d["0"] + " minuter innan du kan prova igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a536535983 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har försökt att logga in för många gånger. Du måste vänta " + d["0"] + " minuter innan du kan prova igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a73168350 = messageFormatterFn((function(  ) {
  return function(d) { return "Få tillgång till en hel värld av förmåner med endast ett konto på Expedia, Hotels.com och Vrbo."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a385857434 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd ett konto för att få tillgång till en hel värld av resor på Expedia, Hotels.com och Vrbo."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a83635617 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter och spara boenden, planera med din grupp och få tillgång till dina bokningsuppgifter."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1941434848 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt konto har pausats till följd av en rutinmässig säkerhetskontroll. Din information är säker, men du måste återställa ditt lösenord."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1971328848 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in och boka din vistelse för att tjäna OneKeyCash"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1091520388 = messageFormatterFn((function(  ) {
  return function(d) { return "Låt oss bekräfta att det är du"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1460054826 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange säkerhetskoden som vi skickade till dig via e-post. Kontrollera din skräppostmapp om du inte ser koden."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a33374422 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekräfta din e-postadress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a373424708 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange säkerhetskoden vi skickade till " + d["0"] + " för att fortsätta. Kontrollera din skräppostmapp om du inte ser koden."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1210208706 = messageFormatterFn((function(  ) {
  return function(d) { return "Sexsiffrig kod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1311964738 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka ny kod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b881744103 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b844822433 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka ny kod inom 00:" + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b928745233 = messageFormatterFn((function(  ) {
  return function(d) { return "Fick du inget e-postmeddelande?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1767964467 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan begära en ny kod om " + d["0"] + " s"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1794907004 = messageFormatterFn((function(  ) {
  return function(d) { return "Begär en ny säkerhetskod"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b132616570 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har skickat en sexsiffrig kod till din inkorg."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1910749999 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange lösenord istället"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1847878768 = messageFormatterFn((function(  ) {
  return function(d) { return "Ogiltig kod. Försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1338589886 = messageFormatterFn((function(  ) {
  return function(d) { return "Koden har gått ut. Skicka en ny kod och försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b38251085 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontrollera din skräppostmapp om du inte ser koden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1341935322 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har uppdaterat användarupplevelsen och måste uppdatera din e-postadress. Ange säkerhetskoden som vi skickade till din inkorg."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1398990363 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett fel har inträffat hos oss. Försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b57484882 = messageFormatterFn((function(  ) {
  return function(d) { return "För att uppdatera din inloggningsmetod, anger du säkerhetskoden som vi skickade till dig via e-post."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a189933336 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ditt lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2030570159 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka en säkerhetskod via e-post"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a36804847 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postadressen och lösenordet matchar inte varandra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1230268088 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa ett lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1195795806 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa ett lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1054328056 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan använda samma e-postadress och lösenord till att logga in på Expedia, Hotels.com och Vrbo."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a574698792 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a883134581 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ett lösenord som kan användas utöver andra säkra inloggningsmetoder."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1909680042 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange nytt lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1115937004 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange nytt lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a716016454 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan nu använda ett och samma konto till att logga in på Expedia, Hotels.com och Vrbo. Skapa ett nytt lösenord som är säkert för ditt kombinerade konto."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2072959974 = messageFormatterFn((function(  ) {
  return function(d) { return "Skapa lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b675159282 = messageFormatterFn((function(  ) {
  return function(d) { return "Byt lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b667382174 = messageFormatterFn((function(  ) {
  return function(d) { return "Använd ett lösenord som är unikt och starkt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b395314306 = messageFormatterFn((function(  ) {
  return function(d) { return "Uppdatera lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1633730581 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kunde inte ändra ditt lösenord. Försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2031511607 = messageFormatterFn((function(  ) {
  return function(d) { return "Glömt lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2124651919 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange din e-post så skickar vi en säker inloggningskod."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b388859633 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka e-post"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2088711461 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontakta oss"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a252456820 = messageFormatterFn((function(  ) {
  return function(d) { return "Radera konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a444860841 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1422331213 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett ögonblick – vi kikar på ditt konto."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a833047634 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1612315722 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a406087374 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kan tyvärr inte ta bort ditt konto förrän din resa har slutförts."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1138090479 = messageFormatterFn((function(  ) {
  return function(d) { return "För att din resa ska gå så smidigt som möjligt behöver du kontot för att hantera din bokning och få hjälp av vår kundtjänst om något ändras i sista minuten."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b304508796 = messageFormatterFn((function(  ) {
  return function(d) { return "Du måste tyvärr ta bort ditt ägarkonto på Vrbo först"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1429445235 = messageFormatterFn((function(  ) {
  return function(d) { return "Gå till vårt hjälpcenter på webbsidan eller i appen för att kontakta vår kundtjänst direkt och påbörja processen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2094647075 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök igen när du har slutfört resan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1318395968 = messageFormatterFn((function(  ) {
  return function(d) { return "Berätta varför du vill ta bort ditt konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2038836687 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag får för många e-postmeddelanden eller aviseringar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1471374693 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag har ett annat " + d["0"] + "-konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1194918752 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag har slutfört min resa, så jag behöver inte kontot längre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b781701210 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag är inte nöjd med bokningsupplevelsen på " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a935474105 = messageFormatterFn((function(  ) {
  return function(d) { return "Annat"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b685129244 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoppa över"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a951458155 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b444233477 = messageFormatterFn((function(  ) {
  return function(d) { return "Så tråkigt att höra att du vill lämna oss. Här är några saker du bör tänka på:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1040222066 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " Expedia Rewards-poäng till ett värde av " + d["1"] + ", " + d["2"] + " i kredit, kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1792136831 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " Expedia Rewards-poäng till ett värde av " + d["1"] + ", kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1106387263 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om dina resetavlor, kredit och preferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1129994039 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: Du kommer gå miste om " + d["0"] + " bonusnätter till ett värde av " + d["1"] + " och " + d["2"] + " stämplar till ett genomsnittligt värde av " + d["3"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1271945608 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om kredit, kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b332562128 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " CheapCash till ett värde av " + d["1"] + ", " + d["2"] + " i kredit, kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b388498943 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " CheapCash till ett värde av " + d["1"] + ", kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1699077336 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " Orbucks till ett värde av " + d["1"] + ", " + d["2"] + " i kredit, kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a400878857 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " Orbucks till ett värde av " + d["1"] + ", kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a671302002 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " MrJet Rewards till ett värde av " + d["1"] + ", " + d["2"] + " i kredit, kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1648960385 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " MrJet Rewards till ett värde av " + d["1"] + ", kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2030989904 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " BONUS+ till ett värde av " + d["1"] + ", " + d["2"] + " i kredit, kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1025829663 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " BONUS+ till ett värde av " + d["1"] + ", kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b215854886 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a641044847 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kommer gå miste om " + d["0"] + " i kredit, kuponger, sparade resekomponenter och kontopreferenser för alltid."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1868883353 = messageFormatterFn((function(  ) {
  return function(d) { return "Det är möjligt att vi behåller vissa uppgifter på ett tryggt sätt, till exempel din transaktionshistorik, för att kunna uppfylla våra lagstadgade skyldigheter eller för att upprätthålla, utöva eller försvara oss mot rättsliga anspråk. Dessa uppgifter kommer att förvaras säkert och kommer att raderas, anonymiseras eller göras permanent oigenkännliga när de inte längre behövs."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1231630437 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort kontot permanent"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a578238507 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta inte bort kontot"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1007104545 = messageFormatterFn((function(  ) {
  return function(d) { return "Du är alltid välkommen tillbaka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1104993150 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan ta några veckor att behandla din begäran om borttagning. Det är möjligt att du kommer fortsätta att ta emot kommunikation tills vårt system har uppdaterats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a994423836 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök igen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1960290053 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett systemfel har inträffat. Skicka din kontoradering på nytt eller försök igen om några minuter."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2002158605 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1301040550 = messageFormatterFn((function(  ) {
  return function(d) { return "Vilket namn använder du på ditt rese-ID?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a521726826 = messageFormatterFn((function(  ) {
  return function(d) { return "Matcha ditt kontonamn med det ID du använder när du reser, som till exempel pass eller körkort. Vi kommer att ha det redo nästa gång du bokar."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a580699608 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta emot e-postmeddelanden med erbjudanden, kampanjer och annan information från " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a480844695 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta emot e-postmeddelanden med erbjudanden, kampanjer och annan information från " + d["0"] + ". Du kan välja bort marknadsföringsmejl närsomhelst."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1195173038 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontouppgifter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a322897448 = messageFormatterFn((function(  ) {
  return function(d) { return "Få e-postmeddelanden om kampanjer, erbjudanden och annan information från " + d["0"] + ". Du kan avsluta prenumerationen när som helst."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a581425924 = messageFormatterFn((function(  ) {
  return function(d) { return "Ha full koll"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b855666462 = messageFormatterFn((function(  ) {
  return function(d) { return "Godkännande av marknadsföring"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b451480463 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1096702865 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b223176119 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1262115535 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1082203599 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1689072040 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b40263436 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b968398239 = messageFormatterFn((function(  ) {
  return function(d) { return "Du måste vänta tills din resa är slutförd"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2003516815 = messageFormatterFn((function(  ) {
  return function(d) { return "Du måste vänta till efter dina kommande resor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b937546357 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom ditt konto kan du vid behov få tillgång till bokningsuppgifter och support. Försök igen när du har slutfört resan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1080431303 = messageFormatterFn((function(  ) {
  return function(d) { return "Genom ditt konto kan du vid behov få tillgång till bokningsuppgifter och support. Försök igen när du har slutfört resorna."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1631513138 = messageFormatterFn((function(  ) {
  return function(d) { return "Det går tyvärr inte att radera ditt konto just nu"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a385256412 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontot används även för uthyrning av boenden på Vrbo. För att kunna radera kontot måste du först logga in på Vrbo Owner-appen eller motsvarande webbsida och ta bort dina aktiva annonser."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1543518637 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi vill gärna veta orsaken till att du lämnar oss."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1847796808 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag har ett konto med en annan e-postadress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a231158073 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag är inte nöjd med min bokningsupplevelse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1932490446 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi tycker att det är tråkigt att du lämnar oss. Observera att det inte går att återställa ett raderat konto och att dina data hos Expedia, Hotels.com och Vrbo kommer att påverkas. Här är några saker du bör tänka på:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b965700327 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi tycker att det är tråkigt att du lämnar oss. Observera att det inte går att återställa ett raderat konto och att dina data hos Expedia, Wotif, Hotels.com och Vrbo kommer att påverkas. Här är några saker du bör tänka på:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b49669586 = messageFormatterFn((function(  ) {
  return function(d) { return "Du förlorar din kontohistorik, dina inställningar och dina sparade objekt på Expedia, Hotels.com och Vrbo, utan möjlighet att återställa dem."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1926967417 = messageFormatterFn((function(  ) {
  return function(d) { return "Du förlorar din kontohistorik, dina inställningar och dina sparade objekt på Expedia, Wotif, Hotels.com och Vrbo, utan möjlighet att återställa dem."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b25189022 = messageFormatterFn((function(  ) {
  return function(d) { return "Du förlorar alla dina OneKeyCash, inklusive utestående OneKeyCash, samt din medlemsnivå i One Key med alla dess förmåner för gott."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a22388056 = messageFormatterFn((function(  ) {
  return function(d) { return "Du förlorar utestående OneKeyCash, samt din medlemsnivå i One Key med alla dess förmåner för gott."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b158046957 = messageFormatterFn((function(  ) {
  return function(d) { return "Du förlorar " + d["0"] + " i OneKeyCash, utestående OneKeyCash, samt din medlemsnivå i One Key med alla dess förmåner för gott."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1108969565 = messageFormatterFn((function(  ) {
  return function(d) { return "Innehavare av Hotels.com Rewards-kreditkort får inte längre poäng baserat på sin kortaktivitet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2010693312 = messageFormatterFn((function(  ) {
  return function(d) { return "Du förlorar alla Expedia Rewards-poäng, inklusive alla verifierade och utestående Expedia Rewards-poäng, Hotels.com Rewards-stämplar, bonusnätter och din Rewards-nivå för gott."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1095479754 = messageFormatterFn((function(  ) {
  return function(d) { return "Du förlorar alla Expedia Rewards-poäng, Hotels.com Rewards-stämplar, bonusnätter och din medlemsnivå för gott."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a53490428 = messageFormatterFn((function(  ) {
  return function(d) { return "Du förlorar alla kuponger och all kredit för Expedia, Hotels.com och Vrbo för gott."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b346884409 = messageFormatterFn((function(  ) {
  return function(d) { return "Du förlorar alla kuponger och all kredit för Expedia, Wotif, Hotels.com och Vrbo för gott."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b313126635 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan ta några veckor att behandla din begäran om borttagning av ditt Expedia-, Hotels.com- eller Vrbo-konto. Det är möjligt att du kommer fortsätta att ta emot kommunikation tills vårt system har uppdaterats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1214898656 = messageFormatterFn((function(  ) {
  return function(d) { return "Det kan ta några veckor att behandla din begäran om borttagning av ditt Expedia-, Wotif-, Hotels.com- eller Vrbo-konto. Det är möjligt att du kommer fortsätta att ta emot kommunikation tills vårt system har uppdaterats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1646711350 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt One Key Card stängs när du tar bort ditt konto och du kommer inte längre att tjäna OneKeyCash på dina köp. Wells Fargo kontaktar dig för att bekräfta stängningen av ditt kort."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a391081120 = messageFormatterFn((function(  ) {
  return function(d) { return "Ditt One Key+ Card stängs när du tar bort ditt konto och du kommer inte längre att tjäna OneKeyCash på dina köp. Wells Fargo kontaktar dig för att bekräfta stängningen av ditt kort."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1257256821 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in eller skapa ett konto för att tjäna OneKeyCash för din resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1729967185 = messageFormatterFn((function(  ) {
  return function(d) { return "Logga in eller skapa ett konto för att tjäna förmåner för vistelsen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b296469814 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala som gäst"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1369120004 = messageFormatterFn((function(  ) {
  return function(d) { return "Inloggning " + d["0"] + "-konto: Lägg till mobilnummer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a523229612 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett fel inträffade"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1525979366 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök logga in igen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2081424751 = messageFormatterFn((function(  ) {
  return function(d) { return "Okej"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2054983589 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b598582521 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1713128889 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a1020431450 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b102022508 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1658987865 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b525865380 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a138734151 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1604846841 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1075352569 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a778860058 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1917559463 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1458254600 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"O","thu":"T","fri":"F","sat":"L"}}}});
Globalize.b1155449977 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"söndag","mon":"måndag","tue":"tisdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lördag"}}}});
Globalize.a1886271879 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a2044317881 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1940389690 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1495233863 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b911751646 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b437476141 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1538193427 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1537508234 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a1825018375 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"söndag","mon":"måndag","tue":"tisdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lördag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b919139814 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"sön","mon":"mån","tue":"tis","wed":"ons","thu":"tors","fri":"fre","sat":"lör"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b219868770 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1334415138 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b1459618639 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a1712894699 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1280274114 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a1289051827 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a517447902 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1226133090 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b696638818 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b1701190031 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b1998694082 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1609427967 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1991610530 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1050111326 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b1667365822 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d"}));
Globalize.a1548982609 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1923092432 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b533037895 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b1582251748 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1159479676 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1158794483 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1207287824 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b540426063 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1394192973 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a279646605 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a2045967648 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.a923513690 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a333787629 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a499670818 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a2131509645 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a387928653 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a917422925 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a1804396256 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b384632339 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a196706802 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^O/],["thu",/^T/],["fri",/^F/],["sat",/^L/]]});
Globalize.a1391787853 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^torsdag/],["sun",/^söndag/],["mon",/^måndag/],["tue",/^tisdag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lördag/]]});
Globalize.a138542413 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["11",/^november/],["12",/^december/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1069814451 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1704585600 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1072882367 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["4",/^apr\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1081023848 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["11",/^november/],["12",/^december/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1209022029 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["11",/^november/],["12",/^december/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a454582067 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["11",/^november/],["12",/^december/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a455267260 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["4",/^apr\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.b733172479 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^torsdag/],["sun",/^söndag/],["mon",/^måndag/],["tue",/^tisdag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lördag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["4",/^apr\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1073635680 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["thu",/^tors/],["sun",/^sön/],["mon",/^mån/],["tue",/^tis/],["wed",/^ons/],["fri",/^fre/],["sat",/^lör/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["4",/^apr\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["3",/^mars/],["6",/^juni/],["7",/^juli/],["5",/^maj/]]});
module.exports = Globalize;
